exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-4499d7ce]{box-shadow:4px 4px 8px 0 rgba(0,0,0,.2);transition:.3s;background-color:#fff;margin-bottom:10px;border-radius:5px}.card[data-v-4499d7ce]:hover{box-shadow:8px 8px 16px 0 rgba(0,0,0,.2)}.container[data-v-4499d7ce]{padding:2px 16px}.card-header[data-v-4499d7ce]{text-align:center;font-size:1em;background-color:#d5e2ee;border-bottom:1px solid #000;padding:5px 10px;border-radius:5px 5px 0 0;font-weight:600}.card-footer[data-v-4499d7ce]{padding:5px 10px;border-top:1px solid #000;display:flex;justify-content:space-around;flex-direction:row}.active[data-v-4499d7ce]{background-color:#92b2f1}", ""]);

// exports
